import { t as defaultT } from '@app/i18n';

export const DEFAULT_TELEHEALTH_PROVIDERS = [
  'Teladoc',
  'MdLive',
  'Amwell',
  'DoctorOnDemand',
  'LiveHealthOnline',
];

// Hardcoded ImageKit logos for the default provider list. These replace the
// per-provider Contentful logo lookup so the default cards render the same way
// as in-network configurations (both consume `logo.imageKitUrl`).
export const DEFAULT_TELEHEALTH_LOGOS = {
  Teladoc:
    'https://ik.imagekit.io/2dodkmw2p/bennie-cms/asset-management/d5f4d51a-439d-49a4-8d1c-d571508ab300/Teladoc-3x.png',
  MdLive:
    'https://ik.imagekit.io/2dodkmw2p/bennie-cms/asset-management/4f90c5ea-91a0-4ae5-92ef-33bf0d17d3e0/MDLive-3x.png',
  Amwell:
    'https://ik.imagekit.io/2dodkmw2p/bennie-cms/asset-management/528c3d23-0657-41f7-b417-b8c7c7247b67/Amwell-3x.png',
  DoctorOnDemand:
    'https://ik.imagekit.io/2dodkmw2p/bennie-cms/asset-management/07e4063e-7da0-44b8-b991-627a36488e24/DoctorOnDemand-3x.png',
  LiveHealthOnline:
    'https://ik.imagekit.io/2dodkmw2p/bennie-cms/asset-management/ed8f3122-184c-4696-9855-474dc370f364/LiveHealthOnline-3x.png',
};

export const getDefaultCardList = (t = defaultT) =>
  DEFAULT_TELEHEALTH_PROVIDERS.map((telehealthProvider, index) => ({
    id: index + 1,
    telehealthProvider,
    telehealthLink: t(
      `telehealthScreen.telehealthProviders.${telehealthProvider}.telehealthLink`,
    ),
    description: t(
      `telehealthScreen.telehealthProviders.${telehealthProvider}.description`,
    ),
    logo: {
      imageKitUrl: DEFAULT_TELEHEALTH_LOGOS[telehealthProvider],
      description: telehealthProvider,
    },
  }));
